import { Component, OnInit, ViewChild, Output, EventEmitter } from "@angular/core";
import { RoleService } from "../shared/role.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute } from "@angular/router";
import { RoleStateService } from "../shared/role-state.service";

@Component({
  selector: "app-listroles",
  templateUrl: "./listroles.component.html",
  styleUrls: ["./listroles.component.css"],
})
export class ListRolesComponent implements OnInit {
  role: any = {};
  allRoles: any;
  errorMsg;
  rolesCols;
  displayEdit: boolean = false;
  displayAdd: boolean = false;
  rolName;
  desc;
  priority;
  originalInfo;
  rolSelected;
  searchRole;
  @Output("isGuardActive") isGuardActive = new EventEmitter();

  constructor(
    private _ActivatedRoute: ActivatedRoute,
    private _roleService: RoleService,
    private roleStateService: RoleStateService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.rolesCols = [{ field: "rolName", header: "Role Name" }];

    this.searchRole = this._ActivatedRoute.snapshot.data.users;
    this.rolSelected = {};

    this.roleStateService.roles$.subscribe((roles) => {
      this.allRoles = roles;
    });
  }
  updateRolesList() {
    this.roleStateService.refreshRoles().subscribe();
  }

  showEditForm(role) {
    this.displayEdit = true;

    this._roleService.getRoleInfo(role).subscribe((roleInfo) => {
      this.rolSelected = roleInfo;
    });
  }

  showAddForm() {
    this.displayAdd = true;
  }

  onRoleAdded(newRole: any) {
    this.displayAdd = false;
  }

  onRoleUpdated(updatedRole: any) {
    this.displayEdit = false;
  }

  onRoleDeleted(roleId: string) {
    this.displayEdit = false;
    this.roleStateService.removeRole(roleId);
  }
}
